import { update as budgets } from './budgets';
import { update as modals } from './modals';
import { update as notifications } from './notifications';
import { update as prefs } from './prefs';
import { update as user } from './user';

export const reducers = {
  prefs,
  modals,
  notifications,
  budgets,
  user,
};
